import React from 'react';

export default function ScreenShot() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      height="20"
      width="20"
    >
      <g>
        <g>
          <path
            d="M492,404.571h-47.429c0-23.628,0-90.674,0-114.857c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20
			c0,24.221,0,91.235,0,114.857c-23.628,0-90.674,0-114.857,0c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20
			c24.221,0,91.235,0,114.857,0V492c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-47.429H492c11.046,0,20-8.954,20-20
			C512,413.525,503.046,404.571,492,404.571z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M154.857,0H20C8.954,0,0,8.954,0,20v134.857c0,11.046,8.954,20,20,20s20-8.954,20-20V40h114.857c11.046,0,20-8.954,20-20
			S165.903,0,154.857,0z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M424.571,0H289.714c-11.046,0-20,8.954-20,20s8.954,20,20,20h114.857v114.857c0,11.046,8.954,20,20,20
			c11.046,0,20-8.954,20-20V20C444.571,8.954,435.617,0,424.571,0z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M154.857,404.571H40V289.714c0-11.046-8.954-20-20-20s-20,8.954-20,20v134.857c0,11.046,8.954,20,20,20h134.857
			c11.046,0,20-8.954,20-20C174.857,413.525,165.903,404.571,154.857,404.571z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M20,192.286c-11.046,0-20,8.954-20,20v20c0,11.046,8.954,20,20,20s20-8.954,20-20v-20
			C40,201.24,31.046,192.286,20,192.286z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M424.571,192.286c-11.046,0-20,8.954-20,20v20c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-20
			C444.571,201.24,435.617,192.286,424.571,192.286z"
          />
        </g>
      </g>
      <g>
        <g>
          <path d="M232.286,0h-20c-11.046,0-20,8.954-20,20s8.954,20,20,20h20c11.046,0,20-8.954,20-20S243.332,0,232.286,0z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M232.286,404.571h-20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h20c11.046,0,20-8.954,20-20
			C252.286,413.525,243.332,404.571,232.286,404.571z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
